import {clone} from "../../utils/DBUtils";

export const tempStoreOptions = {
    container: "dailybreak-images-temp",
    region: "us-east-1"
};

export const multiFilePromiseHandler = (observer, promise) => {
    promise.then((result) => {
        let successFiles = result.filesUploaded;
        let failedFiles = result.filesFailed;

        // Send all successful files to observer one at a time
        for (let file of successFiles) {
            observer.next(file);
        }

        // Send error if there where failed files
        // This probably cancels the observable pipeline, but haven't had a failed upload yet
        if (failedFiles.length > 0) {
            observer.error(failedFiles);
        } else {
            observer.complete();
        }
    }).catch((reason) => {
        observer.error(reason);
    });
};

export const makePickOptions = (baseOptions, observer) => {
    let options = clone(baseOptions);

    // Required options, shouldn't be changed so force override
    options.storeTo = tempStoreOptions;
    options.lang = "en";

    let uploadStarted = false;

    // Wrap provided onUploadStarted and onClose so we can complete this
    // observable if user closes picker with 'x' button (i.e. does not upload any files)
    let providedOnUploadStarted = options.onUploadStarted;
    options.onUploadStarted = (files) => {
        try {
            if (providedOnUploadStarted) {
                providedOnUploadStarted(files);
            }
        } catch (err) {
            observer.error(err);
            return;
        }

        // This event is sent if the 'Upload' button was pressed
        // onClose event below needs this flag to differentiate between 'Upload' button and 'x' button press
        uploadStarted = true;
    };

    let providedOnClose = options.onClose;
    options.onClose = () => {
        try {
            if (providedOnClose) {
                providedOnClose();
            }
        } catch (err) {
            observer.error(err);
            return;
        }

        if (!uploadStarted) {
            // Send complete since the 'Upload' button wasn't pressed
            // Assuming the 'x' button is the only other way this event gets fired
            // observer.complete(); // Use this when a way to intercept this in an epic is working
            observer.next();
        }
    };

    return options;
};


// WEBPACK FOOTER //
// ./public/observables/lettables/utils.js